import { sdk } from 'src/utilities/sdk';
import { camelizeResponseData } from 'src/utilities/http-data-casing';
import { Report } from 'src/types/Report';

export const getUserReportsUrl = (corpId: string): string =>
  `/targetedaudiencesgateway/reporting/${corpId}/user-reports`;

export async function getReportsAPI(corpId: string): Promise<Report[]> {
  const response = await sdk.http.get(getUserReportsUrl(corpId));
  return camelizeResponseData(response) as Report[];
}
